import { GoogleMap, Marker, Circle } from "@react-google-maps/api";

const RadialGeofenceMap = ({ center, radius, markerPosition }) => {
  return (
    <>
      <div className="relative">
        <GoogleMap
          mapContainerStyle={{
            height: "500px",
            width: "100%",
            marginTop: "20px",
          }}
          zoom={10}
          center={center}
        >
          <Marker position={markerPosition} />
          <Circle
            center={markerPosition}
            radius={parseFloat(radius) * 1000}
            options={{
              strokeColor: "#73A5C6",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#73A5C6",
              fillOpacity: 0.35,
            }}
          />
        </GoogleMap>
      </div>
    </>
  );
};

export default RadialGeofenceMap;
